import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, inject } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { SMEs } from '../../models/constants';
import { TableConfig } from './app-table-models';
import { GlobalStateService } from '../../services/global-state.service';
import { SortEvent } from 'primeng/api';

@Component({
    selector: 'app-table',
    templateUrl: './app-table.component.html',
    styleUrls: ['./app-table.component.scss'],
    standalone: false
})
export class AppTableComponent implements OnInit {

  private globalStateService = inject(GlobalStateService)

  @Input() config: TableConfig = {};
  @Input() dateHeaderTemplate!: TemplateRef<any>;

  @Input() pagination = true;
  @Input() lazy = false;
  @Input() customSort = false;
  @Input() totalRecordsLazy?: number;
  @Input() rowsPerPage = 15;

  @Output() sortEvent = new EventEmitter<TableLazyLoadEvent>();
  @Output() lazyExpandEvent = new EventEmitter<any>();

  protected nameCols = ['standardNamn', 'synonym', 'name'];
  protected columnFields!: string[];
  protected first = 0;
  private _expanded: any = {};
  protected SMEs = SMEs;
  @Input() loading!: boolean;
  @Input()
  set expandedRows(row: any) {
    if (row) {
      const index = this.config.rows?.indexOf(this.config.rows?.find((r) => r.prov_labb_provtagningsar === row.id));
      const obj: any = {};
      obj[Object.values(row)[0] as string] = true;
      this._expanded = obj;
      if (index) {
        this.first =
        Math.floor(index / this.rowsPerPage) * this.rowsPerPage >= 0 ? (Math.floor(index / this.rowsPerPage) * this.rowsPerPage) : 0;
        this.lazyExpandEvent.emit({first: this.first});
      }
    }
  }

  onSortFunction(e: TableLazyLoadEvent) {
    this.sortEvent.emit(e);
    this.first = e.first ?? 0;
  }

  get expandedRows() {
    return this._expanded;
  }

  protected updateRowsPerPage(numberOfRows: number) {
    this.globalStateService.setRowsPerPage(numberOfRows)
  }

  ngOnInit(): void {
    this.globalStateService.setRowsPerPage(this.rowsPerPage);
    this.globalStateService.rowsPerPage.subscribe(x => this.rowsPerPage = x)
    this.columnFields = this.config?.columns?.map((col) => col.field) as string[];
  }


  protected collapseAll = () => {
    this.expandedRows = {};
  };

  protected hasFilters() {
    return this.config?.columns?.some((col) => col.columnFilter);
  }

  protected getComment(row: any, col: any): string {
    if (col.commentsAsTitle) {
      return row.comments;
    }

    if (row[col.field]?.length) {
      return row[col.field][0].kommentar;
    }

    return row[col.field];
  }

  protected customSortFunction(e: SortEvent) {
    const key = e.multiSortMeta![0].field;
    const order = e.multiSortMeta![0].order;
    const reverse = order === 1 ? -1 : 1;

    this.config.rows?.sort((a: any,b: any) => {
      if (a[key] === '' || a[key] === null) {
        return order
       } else {
         return a[key] < b[key] ? order : reverse
       }
    })
  }
}
